import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"menu\">\n  <path fill-rule=\"evenodd\" d=\"M7 19a2 2 0 0 1 2-2h72a2 2 0 1 1 0 4H9a2 2 0 0 1-2-2Zm0 25a2 2 0 0 1 2-2h72a2 2 0 1 1 0 4H9a2 2 0 0 1-2-2Zm0 25a2 2 0 0 1 2-2h42a2 2 0 1 1 0 4H9a2 2 0 0 1-2-2Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol